<template>
    <div class="container-golf" :class="{ fixed: isFullScreen }">
        <div class="interactive-course">
            <img class="interactive-course__image-hole" src="~@/assets/hole.svg" />
            <a
                v-if="Object.entries(ObjectSavePoint).length > 0"
                id="tracer"
                @click.prevent="toggleLines"
                href=""
                ><img v-if="!allLinesOn" src="@/assets/tracer-off.svg" /><img
                    v-else
                    src="@/assets/tracer.svg"
            /></a>

            <ul id="dispersionMenu">
                <li>
                    <a @click.prevent="toggleScreenSize" id="maximiseIcon" href=""
                        ><maximize-icon
                    /></a>
                </li>
                <li v-if="!readonly">
                    <button
                        class="container-golf__button container-golf__button_plus"
                        :disabled="
                            sizeObjectSavePoint == 10 ||
                            (sizeObjectSavePoint == 9 && showToolsMode && !pointEditingMode)
                        "
                        @click.prevent="saveNewPoint(true, true)"
                    >
                        +
                    </button>
                </li>
            </ul>
            <input
                v-model.number="valueRangeHorizon"
                :disabled="readonly || !showToolsMode"
                :max="maxValueHorizon"
                :min="-maxValueHorizon"
                class="interactive-course__range interactive-course__range_horizon"
                type="range"
                value="0"
                step="1"
                @change="saveNewPoint(true)"
            />
            <input
                v-model.number="valueRangeVertically"
                :disabled="readonly || !showToolsMode"
                :max="maxValueVertically"
                :min="-maxValueVertically"
                class="interactive-course__range interactive-course__range_vertically"
                :class="
                    valueRangeVertically == 0 && valueRangeHorizon !== 0 && showToolsMode
                        ? 'interactive-course__range_priority'
                        : ''
                "
                :style="{
                    width: `${heightVerticallyRange}px`,
                }"
                step="1"
                type="range"
                value="0"
                @change="saveNewPoint(true)"
            />
            <span
                v-if="!readonly"
                v-show="showToolsMode && !pointEditingMode"
                :ref="'item_create-point_' + mainIndex"
                class="interactive-course__item interactive-course__item_pointer_none"
                :style="{
                    ...courseSizeStyles,
                    left: getPositionPoint(valueRangeHorizon, maxValueHorizon),
                    bottom: getPositionPoint(valueRangeVertically, maxValueVertically),
                }"
            />
            <div class="interactive-course__container-point">
                <span
                    v-for="(point, i) in ObjectSavePoint"
                    :key="i"
                    :ref="'itemsPoint_' + mainIndex"
                    :value="i"
                    class="interactive-course__item"
                    :class="
                        !readonly && showToolsMode ? 'interactive-course__item_pointer_none' : ''
                    "
                    :style="{
                        ...courseSizeStyles,
                        left: getPositionPoint(point.horizon, maxValueHorizon),
                        bottom: getPositionPoint(point.vertically, maxValueVertically),
                        background: currentActive && i == currentActive ? '#15F29F' : '#267962',
                    }"
                    @click="editPoint(i)"
                />
            </div>
            <canvas
                :id="'lineTrajectory_' + this.mainIndex"
                class="interactive-course__canvas-container"
                resize="true"
            />
        </div>
        <div class="distance-info">
            <p
                v-if="!readonly"
                v-show="showStartText"
                class="distance-info__text"
                v-text="
                    'Use the sliders to position the shots, and the ‘plus’ button to record them'
                "
            />
            <span
                style="font-size: 16px"
                v-show="!showStartText"
                v-text="getDistanceInfo(valueRangeHorizon, 'X')"
            />
            <span v-show="!showStartText" class="distance-info__border" />
            <span
                style="font-size: 16px"
                v-show="!showStartText"
                v-text="getDistanceInfo(valueRangeVertically, 'Y')"
            />
        </div>
        <div v-if="!readonly" class="container-golf__сontrol-block">
            <div class="container-golf__сontrol-block_row">
                <div class="custom-select" @blur="selectOpen = false">
                    <div
                        class="custom-select__selected"
                        :class="{ selectOpen: selectOpen }"
                        @click="selectOpen = !selectOpen"
                        v-text="
                            Number(selectTrajectoryValue) === 0
                                ? 'Pick a shot shape'
                                : selectTrajectoryOptions[Number(selectTrajectoryValue)]
                        "
                    />
                    <div
                        class="custom-select__items-list"
                        :class="{ 'custom-select__items-list_hide': !selectOpen }"
                    >
                        <div
                            v-for="(option, index) of selectTrajectoryOptions"
                            :key="index"
                            class="custom-select__items"
                            :class="
                                selectTrajectoryValue === index ? 'custom-select__items_active' : ''
                            "
                            @click="onSelectOptions(index)"
                            v-text="option"
                        />
                    </div>
                    <img class="arrow" src="@/assets/arrow-right-white-2.svg" />
                </div>
            </div>
            <!--<button
        class="container-golf__button container-golf__button_save"
        @click.prevent="saveNewPoint(false)"
      >
        Save
      </button>-->
        </div>
    </div>
</template>

<script>
import { MaximizeIcon } from "vue-feather-icons";
import paperjs from "paper";
var debounce = require("debounce");
const paper = paperjs;
export default {
    layout: "DirectionalGraphBrief",
    components: { MaximizeIcon },
    props: {
        readonly: {
            type: Boolean,
            default: false,
        },
        value: {
            required: true,
        },
        mainIndex: {
            type: Number,
        },
    },
    data() {
        return {
            debounce: debounce,
            isFullScreen: false,
            courseSize: 14,
            heightVerticallyRange: "",
            idLastActivePoint: 1,
            lastActivePoint: {},
            maxValueHorizon: 6,
            maxValueVertically: 8,
            ObjectSavePoint: {},
            parseJsonPoint: {},
            pointEditingMode: false,
            scopeArrowTrajectory: [],
            selected: 0,
            selectOpen: false,
            selectTrajectoryValue: 0,
            showStartText: true,
            showToolsMode: true,
            sizeObjectSavePoint: 0,
            valueRangeHorizon: -6,
            valueRangeVertically: -8,
            windowWidth: 0,
            currentActive: false,
            allLinesOn: false,
            linePaths: [],
            lineArcs: [],
            selectTrajectoryOptions: {
                1: "Straight",
                3: "Curved left",
                2: "Curved right",
            },
        };
    },
    computed: {
        inputVal: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit("input", val);
            },
        },
        courseSizeStyles() {
            return {
                width: `${this.courseSize}px`,
                height: `${this.courseSize}px`,
            };
        },
        user() {
            return this.$store.state.user;
        },
    },
    watch: {
        windowWidth() {
            this.changeHeightVerticallyRange();
        },
        valueRangeHorizon() {
            this.showStartText = false;
            setTimeout(() => {
                this.broadcastNewLine();
            }, 0);
            if (this.pointEditingMode) {
                this.ObjectSavePoint[this.idLastActivePoint].horizon = this.valueRangeHorizon;
            }
        },
        valueRangeVertically() {
            this.showStartText = false;
            setTimeout(() => {
                this.broadcastNewLine();
            }, 0);

            if (this.pointEditingMode) {
                this.ObjectSavePoint[this.idLastActivePoint].vertically = this.valueRangeVertically;
            }
        },
    },
    mounted() {
        this.combiningObjectsPoint();
        this.scopeArrowTrajectory[this.mainIndex] = new paper.PaperScope();
        this.scopeArrowTrajectory[this.mainIndex].setup("lineTrajectory_" + this.mainIndex);
        //this.scopeArrowTrajectory.setup('lineTrajectory');
        this.changeHeightVerticallyRange();
        this.$nextTick(() => {
            window.addEventListener("resize", this.getWindowWidth);
            this.getWindowWidth();
        });

        this.$emit("input", this.selectTrajectoryValue);

        this.inputVal = this.ObjectSavePoint;

        //this.drawTrajectoryLine(10,25);
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.getWindowWidth);
    },
    methods: {
        toggleScreenSize() {
            this.isFullScreen = !this.isFullScreen;
            this.$nextTick(() => {
                this.scopeArrowTrajectory[this.mainIndex].setup("lineTrajectory_" + this.mainIndex);
                this.getWindowWidth();
                this.changeHeightVerticallyRange();
            });
        },
        toggleLines() {
            if (this.allLinesOn) {
                this.scopeArrowTrajectory[this.mainIndex].project.activeLayer.removeChildren();
                this.allLinesOn = false;
                return false;
            }

            var entires = Object.entries(this.ObjectSavePoint);

            for (const [key, value] of entires) {
                this.showAllPaths(key, value);
            }

            this.allLinesOn = true;

            //getCoordinatesPoint
        },
        showAllPaths(index, $item) {
            this.scopeArrowTrajectory[this.mainIndex].activate();

            var selectTrajectoryValue = $item["type"];

            var point = this.$refs["itemsPoint_" + this.mainIndex][index - 1];

            const posY = point.offsetTop + point.offsetWidth / 2;
            const posX = point.offsetLeft + point.offsetWidth / 2;

            //   this.scopeArrowTrajectory.project.activeLayer.removeChildren();
            const { width, height } = this.scopeArrowTrajectory[this.mainIndex].view.size;

            var colour;

            if (!selectTrajectoryValue) {
                return false;
            }
            if (Number(selectTrajectoryValue) === 1) {
                this.linePaths[index - 1] = new paper.Path({
                    segments: [
                        [width / 2, height],
                        [posX, posY],
                    ],
                });
                colour = this.user.type == "player" ? "#FFFFFF" : "#267962";
                this.linePaths[index - 1].strokeColor = colour;
                this.linePaths[index - 1].strokeWidth = 3;
                this.linePaths[index - 1].dashArray = [1, 3.5];
            } else if (Number(selectTrajectoryValue) >= 2) {
                const pointC = Number(selectTrajectoryValue) === 2 ? -30 : 30;
                this.lineArcs[index - 1] = new paper.Path.Arc({
                    from: [width / 2, height],
                    through: [(width / 2 + posX) / 2 + pointC, (posY + height) / 2],
                    to: [posX, posY],
                    strokeColor: "black",
                });
                colour = this.user.type == "player" ? "#FFFFFF" : "#267962";
                this.lineArcs[index - 1].strokeColor = colour;
                this.lineArcs[index - 1].strokeWidth = 3;
                this.lineArcs[index - 1].dashArray = [1, 3.5];
            }
        },
        changeHeightVerticallyRange() {
            this.heightVerticallyRange = this.scopeArrowTrajectory[this.mainIndex].view.size.height;
        },
        getWindowWidth() {
            this.windowWidth = document.documentElement.clientWidth;
        },
        getDistanceInfo(value, type) {
            const typeString = type === "X" ? ["left", "right"] : ["short", "long"];
            const sideThrow = value < 0 ? typeString[0] : typeString[1];

            if (!Number(value)) {
                return "0 yds";
            }
            return `${Math.abs(value * 5)} yds ${sideThrow}`;
        },
        onSelectOptions(index) {
            this.selectTrajectoryValue = Number(index);
            this.broadcastNewLine();
            this.selectOpen = false;
            this.$emit("input", this.selectTrajectoryValue);
        },
        returnPointDate() {
            /*
      this.$emit('objectGraph', {
        objectPoint: JSON.stringify(this.ObjectSavePoint),
      });
      */

            this.inputVal = this.ObjectSavePoint;
        },
        saveNewPoint(showToolsMode = true, clickAddNewPoint = false) {
            console.log("saving");

            if (clickAddNewPoint) {
                this.scopeArrowTrajectory[this.mainIndex].project.activeLayer.removeChildren();
            }
            this.allLinesOn = false;
            this.selectOpen = false;

            if (this.pointEditingMode && !clickAddNewPoint) {
                this.pointEditingMode = false;
                this.showToolsMode = false;
                this.returnPointDate();

                return false;
            }

            this.sizeObjectSavePoint = Object.keys(this.ObjectSavePoint).length;

            console.log("object saved point");
            console.log(this.sizeObjectSavePoint);

            if (this.sizeObjectSavePoint < 10 && this.showToolsMode) {
                console.log("yes 1");

                if (clickAddNewPoint) {
                    this.$set(this.ObjectSavePoint, Number(this.sizeObjectSavePoint) + 1, {
                        horizon: Number(this.valueRangeHorizon),
                        vertically: Number(this.valueRangeVertically),
                        type: Number(this.selectTrajectoryValue),
                    });
                } else {
                    console.log("its number 2");
                    console.log(this.ObjectSavePoint);

                    /*
            this.$set(this.ObjectSavePoint, Number(this.sizeObjectSavePoint), {
                  horizon: Number(this.valueRangeHorizon),
                  vertically: Number(this.valueRangeVertically),
                  type: Number(this.selectTrajectoryValue),
                });
                */
                }

                this.sizeObjectSavePoint += 1;
            }
            if (showToolsMode) {
                console.log("yes 2");

                if (!clickAddNewPoint || !this.pointEditingMode) {
                    this.idLastActivePoint += 1;
                } else {
                    this.idLastActivePoint = this.sizeObjectSavePoint;
                }
                if (clickAddNewPoint) {
                    this.valueRangeVertically = this.maxValueVertically * -1;
                    this.valueRangeHorizon = this.maxValueHorizon * -1;
                }
            }

            if (clickAddNewPoint) this.selectTrajectoryValue = 0;

            if (clickAddNewPoint && this.showToolsMode) {
                console.log("yes 3");
                this.$nextTick(() => {
                    const thisPointArray =
                        this.$refs["itemsPoint_" + this.mainIndex][this.sizeObjectSavePoint - 1];
                    if (typeof thisPointArray !== "undefined") {
                        const thisPointElement = thisPointArray[0];
                        this.lastActivePoint = thisPointElement;
                    }
                });
            }

            this.showToolsMode = showToolsMode;
            this.returnPointDate();

            console.log("the input val");
            console.log(this.inputVal);

            this.$emit("saveChartData");
            return true;
        },
        combiningObjectsPoint() {
            if (this.inputVal) this.parseJsonPoint = this.inputVal;
            this.ObjectSavePoint = { ...this.parseJsonPoint, ...this.ObjectSavePoint };
            this.sizeObjectSavePoint = Object.keys(this.ObjectSavePoint).length;
        },
        editPoint(index = 1) {
            this.pointEditingMode = true;
            this.showToolsMode = true;
            const editPoint = this.ObjectSavePoint[index];
            this.valueRangeVertically = editPoint.vertically;
            this.valueRangeHorizon = editPoint.horizon;
            this.lastActivePoint =
                this.$refs["itemsPoint_" + this.mainIndex][this.sizeObjectSavePoint - 1];
            this.currentActive = index;
            this.getCoordinatesPoint(index);
        },
        broadcastNewLine() {
            if (typeof this.ObjectSavePoint[this.idLastActivePoint] !== "undefined") {
                this.ObjectSavePoint[this.idLastActivePoint].type = this.selectTrajectoryValue;
            }

            this.getCoordinatesPoint(this.idLastActivePoint);
        },
        getPositionPoint(value, maxValue) {
            const percent = this.getPercentPoint(value, maxValue);
            const correction = this.courseSize * (percent / 100);
            return `calc(${percent}% - ${correction}px)`;
        },
        getPercentPoint(value, maxValue) {
            const nValue = Number(value);
            const nMaxValue = Number(maxValue);
            return ((nValue + maxValue) * 100) / (nMaxValue * 2);
        },
        getCoordinatesPoint(index = 1) {
            let point;
            this.idLastActivePoint = Number(index);

            if (typeof this.ObjectSavePoint[this.idLastActivePoint] !== "undefined") {
                this.selectTrajectoryValue = this.ObjectSavePoint[this.idLastActivePoint].type;
            }
            if (!this.pointEditingMode && this.showToolsMode) {
                point = this.$refs["item_create-point_" + this.mainIndex];
            } else {
                point = this.$refs["itemsPoint_" + this.mainIndex][index - 1];
            }

            this.lastActivePoint = point;
            const posX = point.offsetTop + point.offsetWidth / 2;
            const posY = point.offsetLeft + point.offsetWidth / 2;
            if (point.offsetWidth > 0 || point.offsetHeight > 0)
                this.drawTrajectoryLine(posX, posY);
        },
        drawTrajectoryLine(posY = 0, posX = 0) {
            this.scopeArrowTrajectory[this.mainIndex].activate();

            this.scopeArrowTrajectory[this.mainIndex].project.activeLayer.removeChildren();
            const { width, height } = this.scopeArrowTrajectory[this.mainIndex].view.size;
            var colour = this.user.type == "player" ? "#FFFFFF" : "#267962";

            if (!this.selectTrajectoryValue) {
                return false;
            }
            if (Number(this.selectTrajectoryValue) === 1) {
                const linePath = new paper.Path({
                    segments: [
                        [width / 2, height],
                        [posX, posY],
                    ],
                });

                linePath.strokeColor = colour;
                linePath.strokeWidth = 3;
                linePath.dashArray = [1, 3.5];
            } else if (Number(this.selectTrajectoryValue) >= 2) {
                const pointC = Number(this.selectTrajectoryValue) === 2 ? -30 : 30;
                const pathArc = new paper.Path.Arc({
                    from: [width / 2, height],
                    through: [(width / 2 + posX) / 2 + pointC, (posY + height) / 2],
                    to: [posX, posY],
                    strokeColor: "black",
                });

                pathArc.strokeColor = colour;
                pathArc.strokeWidth = 3;
                pathArc.dashArray = [1, 3.5];
            } else {
                return false;
            }
            return true;
        },
    },
};
</script>

<style lang="scss">
$color-green: rgba(21, 242, 159, 1);
$color-dark-green: #267962;

.container-golf {
    align-items: center;
    background-image: linear-gradient(
        to bottom,
        #15f29f,
        #0ed392,
        #15b484,
        #1f9673,
        $color-dark-green
    );
    display: flex;
    flex-direction: column;
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Old versions of Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none;
    justify-content: flex-start;
    margin: auto;

    max-width: 800px;
    padding: 20px 6%;
    border-radius: $radius;
    margin-bottom: 20px;
    overflow: hidden;

    #dispersionMenu {
        position: absolute;

        z-index: 2;
        margin-top: env(safe-area-inset-top) !important;
        li {
            display: inline-block;
            float: left;
            margin-right: 10px;
        }
    }
    #maximiseIcon {
        display: block;
        width: 40px;
        height: 40px;
        background: #22b984;
        border-radius: 8px;

        svg {
            margin-left: 10px;
            margin-top: 8px;
            color: white;
            width: 20px;
        }
    }

    &.fixed {
        position: fixed;
        top: 0px;
        left: 0px;
        width: 100%;
        border-radius: 0px;
        height: 100%;
        z-index: 41;

        #tracer {
            margin-top: env(safe-area-inset-top) !important;
        }
    }

    #tracer {
        position: absolute;
        right: -5px;
        top: -5px;
        z-index: 2;
    }

    .interactive-course__canvas-container[resize] {
        height: 100%;
        width: 100%;
    }

    .distance-info {
        align-items: center;
        color: #fff;
        display: flex;
        font-size: 16pt;
        height: 35px;
        justify-content: space-around;
        margin-bottom: 30px;
        margin-top: 24px;
        position: relative;
        width: 100%;

        &__text {
            align-items: center;
            background: #60c45c;
            border-radius: 13px;
            display: flex;
            font-size: 14px;
            line-height: 1.5;
            justify-content: center;
            min-height: 64px;
            padding: 10px 20px;
            text-align: center;
            width: 100%;
            margin-top: 10px;
            //z-index: 20;
            z-index: 2;
        }

        &__border {
            background: $color-dark-green;
            height: 110%;
            position: absolute;
            top: 50%;
            transform: translate(-50%, -50%);
            width: 1px;
        }
    }

    &__сontrol-block {
        align-items: center;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-bottom: 30px;
        width: 100%;

        &_row {
            align-items: center;
            display: flex;
            justify-content: space-between;
            width: 100%;
        }
    }

    &__button {
        border: none;
        border-radius: 13px;
        color: #fff;
        cursor: pointer;
        height: 52px;
        margin: 0;
        overflow: visible;
        padding: 0;
        width: 100%;
        font-family: canada-type-gibson, sans-serif;
        font-size: 16px;
        &_plus {
            display: block;
            width: 40px;
            height: 40px;
            background: #22b984;
            border-radius: 8px;
        }

        &_save {
            background: #60c45c;
            margin-top: 30px;
        }
        &:focus {
            outline: 0;
        }
    }

    &__select-box {
        background: $color-dark-green;
        border-radius: 0.25em;
        border-radius: 13px;
        display: flex;
        height: 52px;
        line-height: 3;
        margin-top: 15px;
        overflow: hidden;
        position: relative;
        width: 75%;

        &:after {
            background: $color-dark-green;
            content: "\25BC";
            cursor: pointer;
            padding: 0 1em;
            pointer-events: none;
            position: absolute;
            right: 0;
            top: 0;
            transition: 0.25s all ease;
        }
    }

    &__select {
        -moz-appearance: none;
        -ms-appearance: none;
        -webkit-appearance: none;
        appearance: none;
        background: $color-dark-green;
        background-image: none;
        border: 0 !important;
        box-shadow: none;
        color: #fff;
        cursor: pointer;
        flex: 1;
        outline: 0;
        padding: 0 0.5em;
    }

    .interactive-course {
        // background-image:
        //   linear-gradient(rgba(0, 145, 0, .7) .1em, transparent .1em),
        //   linear-gradient(90deg, rgba(0, 145, 0, .7) .1em, transparent .1em);

        background-position: center;
        background-size: calc(100% / 13) calc(100% / 17);
        color: #fff;
        max-width: 600px;
        padding-bottom: 107%;
        position: relative;
        width: 100%;

        &__image-hole {
            bottom: 44%;
            left: 50%;
            position: absolute;
            transform: translate(-50%, -50%);
            width: 7%;
        }

        &__item {
            background: $color-dark-green;
            border-radius: 50%;
            cursor: pointer;
            display: block;
            position: absolute;
            margin: 10px;
            z-index: 2;
        }

        &__item_pointer_none {
            pointer-events: none;
        }

        &__canvas-container {
            height: 100%;
            left: 0;
            position: absolute;
            top: 0;
            width: 100%;
        }

        &__range {
            -webkit-appearance: none;
            bottom: calc(50% - 9px);
            left: 50%;
            margin: 9px 0;
            position: absolute;
            transform: translate(-50%, -50%);
            width: 100%;
            z-index: 2;
            //height:10px;

            &_priority {
                z-index: 45 !important;
            }

            &_vertically {
                transform: translate(-50%, -50%) rotate(-90deg);
                width: 266px;
                z-index: 2;
            }

            &_vertically:after {
                background: linear-gradient(
                    90deg,
                    $color-green 0%,
                    $color-green 44%,
                    rgba(255, 255, 255, 0) 44%,
                    rgba(255, 255, 255, 0) 56%,
                    $color-green 55%,
                    $color-green 100%
                );
                content: "";
                height: 1px;
                left: 0;
                position: absolute;
                top: 100%;
                width: 100%;
                z-index: -1;
            }

            &_horizon:after {
                background: linear-gradient(
                    90deg,
                    $color-green 0%,
                    $color-green 42%,
                    rgba(255, 255, 255, 0) 42%,
                    rgba(255, 255, 255, 0) 58%,
                    $color-green 54%,
                    $color-green 100%
                );
                content: "";
                height: 1px;
                left: 0;
                position: absolute;
                top: 100%;
                width: 100%;
                z-index: -1;
            }

            &:focus {
                outline: none;
            }

            &::-webkit-slider-runnable-track {
                background: #fff;
                border-radius: 1.3px;
                cursor: pointer;
                height: 0;
                width: 100%;
                z-index: 10;
            }

            &::-webkit-slider-thumb {
                -webkit-appearance: none;
                background: #fff;
                border: 0 solid rgba(0, 0, 0, 0);
                border-radius: 50px;
                cursor: pointer;
                height: 19px;
                //padding:10px;
                width: 19px;
                margin: 20px;
                margin-top: -8.65px;
            }

            &[disabled="disabled"]::-webkit-slider-thumb {
                opacity: 0;
            }

            &::-moz-range-track {
                background: #fff;
                border: 0.2px solid #010101;
                border-radius: 1.3px;
                cursor: pointer;
                height: 2.1px;
                width: 100%;
            }

            &::-moz-range-thumb {
                background: #fff;
                border: 0 solid rgba(0, 0, 0, 0);
                border-radius: 50px;
                cursor: pointer;
                height: 19px;
                width: 19px;
            }

            &::-ms-track {
                background: transparent;
                border-color: transparent;
                border-width: 8.45px 0;
                color: transparent;
                cursor: pointer;
                height: 2.1px;
                width: 100%;
            }

            &::-ms-fill-lower {
                background: #f2f2f2;
                border: 0.2px solid #010101;
                border-radius: 2.6px;
            }

            &::-ms-fill-upper {
                background: #fff;
                border: 0.2px solid #010101;
                border-radius: 2.6px;
            }

            &::-ms-thumb {
                background: #fff;
                border: 0 solid rgba(0, 0, 0, 0);
                border-radius: 50px;
                cursor: pointer;
                height: 19px;
                margin-top: 0;
                width: 19px;
            }

            &:focus::-ms-fill-lower {
                background: #fff;
            }

            &:focus::-ms-fill-upper {
                background: #fff;
            }
        }
    }

    .custom-select {
        line-height: 40px;
        outline: none;
        position: relative;
        text-align: left;
        width: 100%;

        &__selected {
            align-items: center;
            background-color: $color-dark-green;
            border-radius: 13px;
            color: #fff;
            cursor: pointer;
            display: flex;
            height: 52px;
            padding-left: 1em;
            user-select: none;
            position: relative;
            &:after {
                //background-image: url('@~assets/right-arrow.svg');
                background-repeat: no-repeat;
                background-size: 17px;
                content: " ";
                content: "";
                display: block;
                height: 17px;
                position: absolute;
                right: 1em;
                width: 17px;
            }
        }

        &__items-list {
            background-color: #fff;
            border-radius: 13px;
            color: $color-dark-green;
            left: 0;
            margin-top: 10px;
            overflow: hidden;
            padding: 8px;
            position: absolute;
            right: 0;
            z-index: 1;

            &_hide {
                display: none;
            }
        }

        &__items {
            cursor: pointer;
            padding-left: 1em;
            user-select: none;

            &_active {
                background: #60c45c;
                border-radius: 9px;
                color: #fff;
            }
        }
    }
}
.arrow {
    position: absolute;
    right: 18px;
    top: 20px;
    pointer-events: none;
}

.glow {
    display: flex;
    align-items: center;
    justify-content: center;
}

.glow::after {
    display: flex;
    background: lightpink;
    border-radius: 300px;
    height: 250px;
    width: 250px;
    animation: pulsate 2.5s ease-out;
    animation-iteration-count: infinite;
    opacity: 0;
    content: "";
    z-index: -1;
    margin: auto;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}

@keyframes pulsate {
    0% {
        transform: scale(0.1, 0.1);
        opacity: 0;
    }
    50% {
        opacity: 1;
    }
    100% {
        transform: scale(1.2, 1.2);
        opacity: 0;
    }
}
</style>
